import React from 'react';
import { Provider } from 'react-redux';
import store from './reducers';
import Routes from 'routers';
import AppThemeProvider from 'utils/AppThemeProvider';

function App() {
  return (
    <Provider store={store}>
      <AppThemeProvider>
        <Routes />
      </AppThemeProvider>
    </Provider>
  );
}

export default App;
